import React, { useEffect, useState } from 'react'
import './category.css'
import { Col, Container, Row } from 'react-bootstrap'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeftLong, faClose } from '@fortawesome/free-solid-svg-icons'
import Footer from '../Footer/Footer'
import Modal from '../Modal'
function Category() {
    const [categories, setCategories] = useState([])
    const [inputValue, setInputValue] = useState('')
    const [showbackcross, setBackCrossBtn] = useState(false)
    const [loading, setLoading] = useState('')
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const navigate = useNavigate();
    useEffect(() => {
        categoryData()
    }, [])
    const clearSearch = () => {
        setBackCrossBtn(false)
        setInputValue('')
    }
    const categoryData = () => {
        const search_key = inputValue;
        setLoading(true)
        const data = JSON.stringify({
            search_key
        });
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/categories`,
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(config).then((response) => {
            setLoading(false)
            console.log(response.data);
            setCategories(response.data.categories)
        })
    }
    const categorySearchData = (keyword) => {
        const search_key = keyword;
        if (search_key !== '') {
            searchOperation(search_key)
        }
        else {
            searchOperation('')
        }
    }
    const searchOperation = async (search_key) => {
        setLoading(true)
        const data = JSON.stringify({
            search_text: search_key
        });
        let config = {
            method: 'POST',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/category-search`,
            headers: {
                // 'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };
        await axios.request(config).then((response) => {
            setLoading(false)
            console.log(response.data);
            setCategories(response.data.categories)
        })
    }


    const handleSearch = async (val) => {
        setInputValue(val);
        categorySearchData(val)
    }
    const [dw, setWidth] = useState(0)
    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
    })
    const plan_active = localStorage.getItem('dastaan__plan_active');
    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : null
    return (
        <>
            <Container className='category-detail-container mt-4'>
                <Row className={`${dw > 768 ? 'ml-10' : ''} search-container ${dw < 768 ? 'mt-3' : ''} `}>
                    {
                        dw <= 768 && (
                            <>
                                <Col md={2} lg={2} xs={1} sm={2} className={`mt-3 ${showbackcross === false ? 'none' : ''}`} onClick={clearSearch}>
                                    <FontAwesomeIcon className={'text-white search-backbutton'} icon={faArrowLeftLong} />
                                </Col>
                                <Col md={12} lg={12} xs={showbackcross === false ? 12 : 11} sm={12} className='mb-4'>
                                    <input
                                        placeholder=' 🔍  Search Categories'
                                        style={{ width: showbackcross === true ? '100%' : '100%' }}
                                        className='search-input-box'
                                        value={inputValue}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setInputValue(value);
                                            handleSearch(e.target.value);
                                        }}
                                    />
                                    <div className={`search-erase-btn ${showbackcross === false ? 'none' : ''}`} onClick={clearSearch}>
                                        <FontAwesomeIcon className={'text-white search-backbutton'} icon={faClose} />
                                    </div>
                                </Col>
                            </>
                        )
                    }
                    <Col md={12} lg={12} xs={12} sm={12} >
                        <h5 className='search-heading'>Browse Categories</h5>
                    </Col>
                    {/* 
                        <Col md={12} lg={12} xs={12} sm={12} className='mt-3 ml-2'>
                            <span className='category-heading'>Browse Categories</span>
                        </Col> */}
                    {
                        categories.map((cat) => (
                            <Col md={2} sm={2} xs={6} className={`${dw > 768 ? 'p-1' : 'p-1'}`}
                                onClick={() => (user_id !== null && plan_active === 'true') ? navigate(`/category-details/${cat.id}`) : (user_id !== null && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                            >
                                <div key={cat.id} className="card-wrapper"
                                >
                                    <div className="card">
                                        <div className='image'>
                                            <img
                                                src={cat.category_icon} alt={cat.category_name} className="card-img-top slick-slider-img" />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                    }
                </Row>
            </Container>
            <Modal show={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}
export default Category